<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    export default {
        name: 'products',
        data () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// Products.vue?791ad964